import {
  DownloadFileDto, FileDto,
  ProjectDocument, useDownloadLinkService,
  useMimeTypesHelper,
  useProjectDocumentsService
} from 'nekst-api';
import React, { useState } from 'react';
import { LoadingAnimation, TextLink, usePopupManager } from 'ui-builder';
import useDataLoader from 'data-loader';
import { PDFViewer } from '../PDFViewer';
import { Popup } from '../Popup';

function PreviewDocumentPopup(
  props: {
    document: ProjectDocument,
  }
) {
  const [document, setDocument] = useState<DownloadFileDto>();

  const projectDocumentsService = useProjectDocumentsService();

  const mimeTypesHelper = useMimeTypesHelper();

  useDataLoader(
    () => projectDocumentsService.getDownloadLink(props.document.id),
    setDocument
  );

  let content;

  if (document) {
    if (mimeTypesHelper.isPdfMimeType(document.mimeType)) {
      content = <PDFViewer pdfUrl={document.downloadUrl} fileName={document.fileName} />;
    } else {
      content = (<span>Preview is not available for this file type.</span>);
    }
  } else {
    content = <LoadingAnimation />;
  }

  return (<Popup title="Preview Document" content={content} isBig />);
}

function PreviewFilePopup(
  props: {
    file: FileDto,
  }
) {
  const [document, setDocument] = useState<DownloadFileDto>();

  const linkService = useDownloadLinkService();

  const mimeTypesHelper = useMimeTypesHelper();

  useDataLoader(
    () => linkService.getFileDownloadLinkById(props.file.id),
    setDocument
  );

  let content;

  if (document) {
    if (mimeTypesHelper.isPdfMimeType(document.mimeType)) {
      content = <PDFViewer pdfUrl={document.downloadUrl} fileName={document.fileName} />;
    } else {
      content = (<span>Preview is not available for this file type.</span>);
    }
  } else {
    content = <LoadingAnimation />;
  }

  return (<Popup title="Preview Document" content={content} isBig />);
}


export function usePreviewDocumentPopup() {
  const popupManager = usePopupManager();

  const openPreviewPopup = (document: ProjectDocument) => {
    popupManager.openPopup(<PreviewDocumentPopup document={document} />);
  };

  return {
    openPreviewPopup
  };
}

export function PreviewDocumentWidget(props: { document: ProjectDocument }) {

  const previewDocumentPopup = usePreviewDocumentPopup();

  const mimeTypesHelper = useMimeTypesHelper();

  if (props.document._file) {
    const mimeType = props.document._file.mimeType;
    const isPreviewAvailable = mimeTypesHelper.isPdfMimeType(mimeType);

    if (isPreviewAvailable) {
      return (
        <TextLink
          onClick={() => {
            previewDocumentPopup.openPreviewPopup(props.document)
          }}
        >
          {props.document._file.name}
        </TextLink>
      );
    } else {
      return (<span>{props.document._file.name}</span>);
    }
  } else {
    return (<span>-</span>);
  }

}


export function PreviewFileWidget(props: { file: FileDto }) {
  const popupManager = usePopupManager();


  const mimeTypesHelper = useMimeTypesHelper();

  const mimeType = props.file.mimeType;
  const isPreviewAvailable = mimeTypesHelper.isPdfMimeType(mimeType);

  if (isPreviewAvailable) {
    return (
      <TextLink
        onClick={() => {
          popupManager.openPopup(<PreviewFilePopup file={props.file} />);
        }}
      >
        {props.file.name}
      </TextLink>
    );
  } else {
    return (<span>{props.file.name}</span>);
  }

}
